import { QueryFactory } from "../../../../Common";
export const QGetSportsGroupedByDate = QueryFactory("GetSportsGroupedByDate");
//# sourceMappingURL=QGetSportsGroupedByDate.js.map